// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;I cry out to you, O Lord, and say:&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;&#145;You are my refuge, my portion in the land of the living.<br> </p> </div></div>";
// Exports
module.exports = code;